export default __webpack_public_path__ + "static/media/footer-bg-min.8ba4434d.png";